module.exports = __webpack_public_path__ + "media/images/ui__textArrowRightLight--dark-44ab81197514ac7a98e0227dc0b6df6c.png";